export function Sparkle({ className = "", color = "#FFD166" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path d="M12 0 C13 8 16 11 24 12 C16 13 13 16 12 24 C11 16 8 13 0 12 C8 11 11 8 12 0Z" fill={color} />
    </svg>
  );
}

// Signature flowing S-ribbons inspired by the SparkIdea emblem.
export function Ribbons({ className = "", id = "r" }) {
  return (
    <svg viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={`${id}-cool`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#17B6F4" stopOpacity="0" />
          <stop offset="0.35" stopColor="#17B6F4" />
          <stop offset="1" stopColor="#176BFF" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient id={`${id}-warm`} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#F98A17" stopOpacity="0" />
          <stop offset="0.5" stopColor="#F98A17" />
          <stop offset="1" stopColor="#FFD166" stopOpacity="0" />
        </linearGradient>
        <filter id={`${id}-glow`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="18" />
        </filter>
      </defs>
      <g filter={`url(#${id}-glow)`} opacity="0.55">
        <path d="M-100 620 C 200 420, 420 760, 640 520 S 980 160, 1320 260" stroke={`url(#${id}-cool)`} strokeWidth="90" fill="none" />
        <path d="M-80 760 C 260 560, 520 820, 760 600 S 1060 300, 1300 420" stroke={`url(#${id}-warm)`} strokeWidth="40" fill="none" opacity="0.6" />
      </g>
      <path d="M-100 620 C 200 420, 420 760, 640 520 S 980 160, 1320 260" stroke={`url(#${id}-cool)`} strokeWidth="1.5" fill="none" />
      <path d="M-100 650 C 220 450, 430 790, 660 545 S 1000 190, 1320 300" stroke="#17B6F4" strokeOpacity="0.35" strokeWidth="1" fill="none" />
      <path className="ribbon-flow" d="M-100 620 C 200 420, 420 760, 640 520 S 980 160, 1320 260" stroke="#7fe0ff" strokeWidth="2" fill="none" strokeLinecap="round" />
      <path d="M-80 760 C 260 560, 520 820, 760 600 S 1060 300, 1300 420" stroke={`url(#${id}-warm)`} strokeWidth="1.5" fill="none" />
      <path className="ribbon-flow" style={{ animationDelay: "-6s", animationDuration: "18s" }} d="M-80 760 C 260 560, 520 820, 760 600 S 1060 300, 1300 420" stroke="#FFD166" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    </svg>
  );
}

export function Atmosphere({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      <div className="aurora absolute -left-[10%] -top-[20%] h-[70%] w-[60%] rounded-full bg-[radial-gradient(closest-side,rgba(23,107,255,0.28),transparent)]" />
      <div className="aurora absolute -right-[10%] top-[10%] h-[60%] w-[50%] rounded-full bg-[radial-gradient(closest-side,rgba(23,182,244,0.18),transparent)]" style={{ animationDelay: "-8s" }} />
      <div className="absolute bottom-[-20%] left-[30%] h-[50%] w-[40%] rounded-full bg-[radial-gradient(closest-side,rgba(249,138,23,0.12),transparent)]" />
    </div>
  );
}
